import { Calculation, CalculationUtils } from "@/models/Calculation";
import { Federation, AssociationUtils } from "@/models/Federation";
import { InvoiceData } from "@/types";
import { InvoiceDataUtils } from "@/types/invoice-data";

const missingCalculations = (
  calculations: Calculation[],
  associations: Federation[],
  year: number
): Calculation[] => {
  const result = [];

  for (const org of associations) {
    const [contingentExists, serviceFeeExists] =
      CalculationUtils.checkExistance(calculations, year, org);

    const orgNumber = AssociationUtils.getOrganizationNumberByMo(
      associations,
      org.nhoNumber
    );
    if (!contingentExists) {
      const contingent = CalculationUtils.createUniqueItem(
        year,
        org.nhoNumber,
        "Contingent",
        orgNumber
      );
      result.push(contingent);
    }

    if (!serviceFeeExists) {
      const serviceFee = CalculationUtils.createUniqueItem(
        year,
        org.nhoNumber,
        "ServiceFee",
        orgNumber
      );
      result.push(serviceFee);
    }
  }

  return result;
};

const missingInvoiceData = (
  invoiceData: InvoiceData[],
  federations: Federation[]
): InvoiceData[] => {
  const result = [];

  for (const federation of federations) {
    const { nhoNumber } = federation;

    const [
      orderLineTypeWithDiscountContingent,
      orderLineTypeWithoutDiscountContingent,
    ] = InvoiceDataUtils.getOrderLineTypeFromCalculationType("Contingent");

    const itemWithoutDiscountContingent = InvoiceDataUtils.createUniqueItem(
      nhoNumber,
      orderLineTypeWithoutDiscountContingent,
      "1000"
    );
    const itemWithDiscountContingent = InvoiceDataUtils.createUniqueItem(
      nhoNumber,
      orderLineTypeWithDiscountContingent,
      "1000"
    );

    if (
      !InvoiceDataUtils.checkExistance(
        invoiceData,
        itemWithoutDiscountContingent
      )
    )
      result.push(itemWithoutDiscountContingent);
    if (
      !InvoiceDataUtils.checkExistance(invoiceData, itemWithDiscountContingent)
    )
      result.push(itemWithDiscountContingent);

    const [
      orderLineTypeWithDiscountServiceFee,
      orderLineTypeWithoutDiscountServiceFee,
    ] = InvoiceDataUtils.getOrderLineTypeFromCalculationType("ServiceFee");

    const itemWithoutDiscountServiceFee = InvoiceDataUtils.createUniqueItem(
      nhoNumber,
      orderLineTypeWithoutDiscountServiceFee,
      "1002"
    );
    const itemWithDiscountServiceFee = InvoiceDataUtils.createUniqueItem(
      nhoNumber,
      orderLineTypeWithDiscountServiceFee,
      "1002"
    );

    if (
      !InvoiceDataUtils.checkExistance(
        invoiceData,
        itemWithoutDiscountServiceFee
      )
    )
      result.push(itemWithoutDiscountServiceFee);
    if (
      !InvoiceDataUtils.checkExistance(invoiceData, itemWithDiscountServiceFee)
    )
      result.push(itemWithDiscountServiceFee);
  }

  return result;
};

export { missingCalculations, missingInvoiceData };
